import { Roles } from '@/lib/context';

export const contentRoleOptions: { label: string; value: Roles }[] = [
  { label: 'Admin', value: Roles.Administrator },
  { label: 'Bevoegd gezag', value: Roles.Bevoegdgezag },
  { label: 'Geaccepteerd deskundigen', value: Roles.Dienstverlener },
  { label: 'Glastuinbouwondernemers', value: Roles.Deelnemer },
  { label: 'Keyusers bevoegd gezag', value: Roles.KeyuserBevoegdgezag },
];

export const allContentRoleValues = contentRoleOptions.map(option => option.value);

const backendEnumIndexMap: Record<number, Roles> = {
  1: Roles.Administrator,
  2: Roles.Bevoegdgezag,
  3: Roles.Dienstverlener,
  4: Roles.Deelnemer,
  9: Roles.KeyuserBevoegdgezag,
};

export const normalizeContentRole = (role: unknown): Roles | undefined => {
  if (typeof role === 'string' && (allContentRoleValues as string[]).includes(role)) {
    return role as Roles;
  }

  if (typeof role === 'number') {
    return backendEnumIndexMap[role];
  }

  return undefined;
};

export const getContentRoleLabel = (role: unknown): string => {
  const normalizedRole = normalizeContentRole(role);
  const label = contentRoleOptions.find(option => option.value === normalizedRole)?.label;
  if (label) {
    return label;
  }

  if (typeof role === 'string' || typeof role === 'number') {
    return String(role);
  }

  return '-';
};
